@let hasQualificationEditPermission =
  can(RoleAction.Update, RolePermissionSubject.UserQualificationV2);
@let selectionCount = selectionCount$ | async;
<button
  nz-button
  nzType="default"
  (click)="showBulkEditDrawer()"
  [disabled]="
    !hasQualificationEditPermission ||
    !selectionCount ||
    selectionCount.count <= 0
  "
  nz-tooltip
  [nzTooltipTitle]="'general.no_permissions' | translate"
  [nzTooltipTrigger]="!hasQualificationEditPermission ? 'hover' : null"
>
  {{
    ('general.edit' | translate) +
      (hasQualificationEditPermission &&
      selectionCount &&
      selectionCount.count > 0
        ? ' (' + selectionCount.count + ')'
        : '')
  }}
</button>
